"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const getSession_1 = (0, tslib_1.__importDefault)(require("./getSession"));
const getSignature_1 = (0, tslib_1.__importDefault)(require("./getSignature"));
const getJWT_1 = (0, tslib_1.__importDefault)(require("./getJWT"));
function default_1(body, getHeaders = () => { }) {
    const jwt = (0, getJWT_1.default)();
    const headers = getHeaders(body);
    if (jwt) {
        return {
            'X-ORION-JWT': jwt,
            ...headers
        };
    }
    const session = (0, getSession_1.default)();
    if (!session)
        return { ...headers };
    const { publicKey, secretKey } = session;
    if (!publicKey || !secretKey)
        return { ...headers };
    const nonce = new Date().getTime();
    const signature = (0, getSignature_1.default)(nonce + body, session);
    return {
        'X-ORION-NONCE': nonce,
        'X-ORION-PUBLICKEY': publicKey,
        'X-ORION-SIGNATURE': signature,
        ...headers
    };
}
exports.default = default_1;
